const Location = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_559_1375)">
        <path
          d="M8.88754 8.92927C8.39289 8.7581 7.74838 8.62863 7.03309 8.55446C7.14287 8.3878 7.25528 8.21286 7.368 8.03169C8.38948 6.3897 8.90743 5.09062 8.90743 4.17053C8.90741 2.34422 7.42159 0.858398 5.59529 0.858398C3.769 0.858398 2.28318 2.34422 2.28318 4.17053C2.28318 5.09062 2.80113 6.3897 3.82261 8.03169C3.93531 8.21286 4.04773 8.3878 4.15752 8.55446C3.44225 8.62863 2.7977 8.75808 2.30307 8.92927C1.53173 9.19619 1.14062 9.55325 1.14062 9.99049C1.14062 10.4805 1.6283 10.8678 2.59008 11.1418C3.39726 11.3718 4.46454 11.4984 5.59529 11.4984C6.72604 11.4984 7.79333 11.3718 8.60053 11.1418C9.56231 10.8678 10.05 10.4805 10.05 9.99047C10.05 9.55325 9.6589 9.19619 8.88754 8.92927ZM2.95138 4.17053C2.95138 2.71265 4.13743 1.5266 5.59529 1.5266C7.05316 1.5266 8.23921 2.71265 8.23921 4.17053C8.23921 4.95174 7.74293 6.16296 6.80406 7.67319C6.34196 8.41648 5.87536 9.06446 5.59527 9.43977C5.3152 9.06448 4.8486 8.4165 4.38649 7.67319C3.44766 6.16296 2.95138 4.95176 2.95138 4.17053ZM8.41745 10.4992C7.6681 10.7126 6.66584 10.8302 5.59529 10.8302C4.52475 10.8302 3.52247 10.7126 2.77314 10.4992C1.97645 10.2722 1.8088 10.029 1.8088 9.99049C1.8088 9.95416 1.93563 9.7635 2.52158 9.56073C3.04978 9.37796 3.77787 9.24669 4.58751 9.18711C5.00407 9.78156 5.31371 10.1732 5.33353 10.1981C5.39692 10.278 5.49332 10.3246 5.59529 10.3246C5.69727 10.3246 5.79365 10.278 5.85705 10.1981C5.87688 10.1731 6.18652 9.78156 6.60308 9.18711C7.41274 9.24669 8.14083 9.37794 8.66903 9.56073C9.25496 9.76352 9.38178 9.95416 9.38178 9.99047C9.38176 10.029 9.21414 10.2722 8.41745 10.4992Z"
          fill="white"
        />
        <path
          d="M5.59487 2.62354C4.7413 2.62354 4.04688 3.31798 4.04688 4.17153C4.04688 5.02508 4.74132 5.71953 5.59487 5.71953C6.44842 5.71953 7.14287 5.02508 7.14287 4.17153C7.14287 3.31798 6.44844 2.62354 5.59487 2.62354ZM5.59487 5.05135C5.10975 5.05135 4.71508 4.65667 4.71508 4.17155C4.71508 3.68641 5.10975 3.29176 5.59487 3.29176C6.07999 3.29176 6.47467 3.68643 6.47467 4.17155C6.47467 4.65667 6.07999 5.05135 5.59487 5.05135Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_559_1375">
          <rect
            width="10.64"
            height="10.64"
            fill="white"
            transform="translate(0.275391 0.858398)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Location;
